const translations = {
  "en": {
    "Allow Access to the Microphone": "Allow Access to the Microphone",
    "Cancel": "Cancel",
    "Just speak to type and go completely hands-free": "Just speak to type and go completely hands-free",
    "Open Settings": "Open Settings"
  },
  "zh-tw": {
    "Allow Access to the Microphone": "允許使用麥克風",
    "Cancel": "取消",
    "Just speak to type and go completely hands-free": "只需語音輸入即可完全無需手動操作",
    "Open Settings": "開啟設定"
  }
};

export default translations;
